import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import UserNav from './UserNav';

import { actions, selectors } from 'modules/user';

class UserNavContainer extends PureComponent {
  state = {
    menuShown: false,
  };

  toggleMenu = menuState => {
    this.setState(state => ({
      menuShown: menuState !== undefined ? menuState : !state.menuShown,
    }));
  };

  render() {
    return <UserNav onToggleMenu={this.toggleMenu} {...this.state} {...this.props} />;
  }
}

const mapStateToProps = state => ({
  user: selectors.user(state),
  isLoggedIn: selectors.isLoggedIn(state),
});

export default connect(mapStateToProps, {
  onLoginFacebook: actions.loginFacebook,
  onLoginGoogle: actions.loginGoogle,
  onLogout: actions.logout,
})(UserNavContainer);



// WEBPACK FOOTER //
// ./src/components/UserNav/UserNav.container.js